// frontend/src/components/RewardToast.js - Toast notification for earned rewards

import React, { useEffect, useState } from 'react';
import './RewardToast.css';

const RewardToast = ({ message, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onClose, 300); // Wait for fade out animation
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`reward-toast ${visible ? 'visible' : 'hidden'}`}>
      <div className="reward-toast-content">
        <span className="reward-icon">🎉</span>
        <span className="reward-text">{message}</span>
      </div>
    </div>
  );
};

export default RewardToast;